import type { CommonRequestOptions } from '@3ds/common-request-proxification'
import { CommonRequest } from '@3ds/common-request-proxification'

import { logger } from '~/features-shared/libs/utils/logger'

/**
 * Utility to proxify a URL for native context
 *
 * @param url The URL to proxify
 * @returns The proxified URL
 */
export function proxifyUrl(url: string, options?: Partial<CommonRequestOptions>) {
  try {
    return CommonRequest.proxifyUrl(url, { proxy: 'passport', ...options })
  }
  catch (error) {
    logger.error(url, error)
    return url
  }
}

export interface Data {
  app: string
  content: URLSearchParams
}

/**
 * Parse 3DDashboard like URL.
 *
 * @example eg: "#app:X3D_FOO/content:route=/test/" -> { app: 'X3D_FOO', content: { route: '/test/' } }
 */
export function parseHash(hash: string): Data {
  const DATA_PREFIXES = ['#app:', 'content:']
  const SEPARATOR = '/'
  const [app, content] = hash
    .split(SEPARATOR)
    .map((data, index) => data.replace(DATA_PREFIXES[index], ''))
  return {
    app,
    content: new URLSearchParams(content),
  }
}

/**
 * Utility to slugify a string for a usable URL
 *
 * @param strURL The string to slugify
 * @returns The slugified string
 */
export function slugifyString(strURL: string) {
  return strURL.replace(/[^a-zA-Z0-9-_]/g, '_') // Replace unwanted characters
    .replace(/^_+|_+$/g, '') // Remove leading/trailing underscores
    .replace(/_{2,}/g, '_') // Replace multiple underscores with a single one
    .replace(/^\d+/, '') // Replace number leading string
    .toLocaleLowerCase()
}
